import { render, staticRenderFns } from "./ApproverMaster.vue?vue&type=template&id=ef33c800&scoped=true"
import script from "./ApproverMaster.vue?vue&type=script&lang=js"
export * from "./ApproverMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef33c800",
  null
  
)

export default component.exports